// CAD智绘园林模块
export default {
  namespaced: true,
  state() {
    return {
      showCertificate: false // 检查是否有授权证书栏目
    }
  },
  mutations: {
    setShowCertificate(state, payload) {
      state.showCertificate = payload
    }
  }
}
